import { SeeqNames } from '@seeqdev/constants';
import { fcCapsuleSet, fcScalar, fcSeries } from '@seeqdev/icons/seeq';
import type { IconDefinition } from '@seeqdev/icons';

const packageName = SeeqNames.MlService.PlsRegression.Connection.UdfPackage;
const udfName = SeeqNames.MlService.PlsRegression.Connection.UdfName;
export const UDF_NAME = `${packageName}_${udfName}`;

export const DEFAULT_NUM_COMPONENTS = 2;
export const VALIDATION_ERROR_DELAY = 500;
export const DEFAULT_SCALE = true;
export const DEFAULT_TOLERANCE = 1e-6;
export const DEFAULT_MAX_ITERATIONS = 500;
export const MAX_INPUT_SIGNALS = 50;

export const INPUT_NAMES = {
  targetSignalInput: 'targetSignalInput',
  nComponentsInput: 'nComponentsInput',
  scaleInput: 'scaleInput',
  maxIterationsInput: 'maxIterationsInput',
  toleranceInput: 'toleranceInput',
  startTimeInput: 'startTimeInput',
  endTimeInput: 'endTimeInput',
  signalNameInput: 'signalNameInput',
  rSquaredNameInput: 'rSquaredNameInput',
  modelInputPropNameInput: 'modelInputPropNameInput',
  modelTrainingWindowConditionNameInput: 'modelTrainingWindowConditionNameInput',
  signalInput: 'signalInput',
  restrictOutputToConditionInput: 'restrictOutputToConditionInput',
  trainWithinConditionInput: 'trainWithinConditionInput',
};

export const OUTPUT_TRANSLATION_KEYS: Record<string, { label: string; icon: IconDefinition }> = {
  predictionOutput: {
    label: 'INVESTIGATE_TOOLS.PARTIAL_LEAST_SQUARES_V2.OUTPUTS.PREDICTION',
    icon: fcSeries,
  },
  rSquaredOutput: {
    label: 'INVESTIGATE_TOOLS.PARTIAL_LEAST_SQUARES_V2.OUTPUTS.R_SQUARED',
    icon: fcScalar,
  },
  xWeightsOutput: {
    label: 'INVESTIGATE_TOOLS.PARTIAL_LEAST_SQUARES_V2.OUTPUTS.X_WEIGHTS',
    icon: fcScalar,
  },
  yWeightsOutput: {
    label: 'INVESTIGATE_TOOLS.PARTIAL_LEAST_SQUARES_V2.OUTPUTS.Y_WEIGHTS',
    icon: fcScalar,
  },
  xLoadingsOutput: {
    label: 'INVESTIGATE_TOOLS.PARTIAL_LEAST_SQUARES_V2.OUTPUTS.X_LOADINGS',
    icon: fcScalar,
  },
  yLoadingsOutput: {
    label: 'INVESTIGATE_TOOLS.PARTIAL_LEAST_SQUARES_V2.OUTPUTS.Y_LOADINGS',
    icon: fcScalar,
  },
  coefficientsOutput: {
    label: 'INVESTIGATE_TOOLS.PARTIAL_LEAST_SQUARES_V2.OUTPUTS.COEFFICIENTS',
    icon: fcScalar,
  },
  interceptOutput: {
    label: 'INVESTIGATE_TOOLS.PARTIAL_LEAST_SQUARES_V2.OUTPUTS.INTERCEPT',
    icon: fcScalar,
  },
  modelInputPropertiesOutput: {
    label: 'INVESTIGATE_TOOLS.PARTIAL_LEAST_SQUARES_V2.OUTPUTS.MODEL_INPUT_PROPERTIES',
    icon: fcScalar,
  },
  trainingWindowConditionOutput: {
    label: 'INVESTIGATE_TOOLS.PARTIAL_LEAST_SQUARES_V2.OUTPUTS.TRAINING_WINDOW_CONDITION',
    icon: fcCapsuleSet,
  },
};

export const DEFAULT_OUTPUTS: string[] = ['predictionOutput'];

export const MODEL_NAME = SeeqNames.ModelNames.PartialLeastSquares;
